import type {
  DailyTacticalReadiness,
  MarketStatusSimple,
} from '../../services/operationsApi';

export default function Atu2NextActionPanel({ readiness, market }: Props) {
  const canSmoke = isSmokeReady(readiness, market);
  return (
    <section className="atu2-panel atu2-next">
      <div>
        <span className="atu2-kicker">다음 행동</span>
        <h2>{canSmoke ? '수동 리허설 1회 실행 가능' : '수동 리허설 대기'}</h2>
        <p>{nextDetail(canSmoke, market)}</p>
      </div>
      <ul>
        <li>실제 돈 사용 금지 유지</li>
        <li>브로커 주문 전송 0건 확인</li>
        <li>공식 관찰 기록은 계속 0건 유지</li>
        <li>시장·뉴스·프리마켓·프롬프트 근거 저장 확인</li>
      </ul>
    </section>
  );
}

function isSmokeReady(readiness: DailyTacticalReadiness, market: MarketStatusSimple) {
  return readiness.flags.real_model_enabled
    && readiness.flags.cohort_mode === 'rehearsal'
    && !readiness.flags.scheduler_enabled
    && !readiness.live_order_safety.broker_submit_allowed
    && !readiness.live_order_safety.real_capital_allowed
    && market.is_open;
}

function nextDetail(canSmoke: boolean, market: MarketStatusSimple) {
  if (canSmoke) {
    return '미국장이 열려 있으므로 사전 리허설용 수동 실행을 검토할 수 있습니다.';
  }
  return `현재는 ${market.status_text}. ${market.next_event} 이후 유효한 판단 근거가 있을 때 실행합니다.`;
}

type Props = {
  readiness: DailyTacticalReadiness;
  market: MarketStatusSimple;
};
